const { gql } = require('graphql-tag');

const StoreFragment = require('./storeFragment').fragment;

module.exports = {
  fragment: gql`
    ${StoreFragment}

    fragment StoreQueryResultFragment on StoreQueryResult {
      offset
      count
      total
      results {
        ...StoreFragment
      }
    }
  `,
};
